import { Component, EventEmitter, OnInit, Output } from "@angular/core";

import {  GetLanguageChoices } from "../data/LanguageChoices";
import { PreferencesService } from "../services/preferences.service";

export class LanguageChoice {
  image: string;
  name: string;
  languageCode: string;
  constructor() { }
}
@Component({
  selector: "app-language-chooser",
  template: `
          <div dropdown class='btn-group' >
            <button
              id="languageChoiceDropDown"
              dropdownToggle
              type="button"
              class="btn dropdown-toggle"
            >
              &nbsp;{{ currentLanguage.name }}
            </button>
            <ul id="languageChoiceDropDownList" *dropdownMenu class="dropdown-menu">
              <li
                *ngFor="let language of languages; let i = index"
                (click)="chooseLanguage(i)" class='clickable'
              >
                  &nbsp;{{ language.name }}
                <div class="dropdown-divider"></div>
              </li>
            </ul>
</div>
  `
})
export class LanguageChooserComponent implements OnInit {
  currentLanguage: LanguageChoice;


  @Output() languageChange: EventEmitter<string> = new EventEmitter<string>();

 
  constructor(
    private preferenceService: PreferencesService) {

  }
 languages:any[];

  ngOnInit(): void {

 this.languages=GetLanguageChoices();
   this .preferenceService.languageCode$.subscribe(code=>{
    this.currentLanguage = this.languages.find(x => x.languageCode == code);
   });
   
    
  }
  chooseLanguage(i: number) {
    this.currentLanguage = this.languages[i];
    this.preferenceService.languageCode = this.languages[i].languageCode;
    this.languageChange.emit(this.languages[i].languageCode)
  }
}
